/* Hydrova advertorial pages — shared offer popup + sticky bar.
 *
 * Injects a vanilla-JS clone of the sales-page bundle drawer and opens it from
 * any CTA marked with [data-hydrova-offer] (or href="#offer"). The money path
 * is NOT here: hydrova-sales-commerce.js (loaded alongside, unmodified) owns
 * the Add to Cart button via document-capture listeners. This file only
 * renders UI and manages selection state — keep it that way so both surfaces
 * share one checkout mechanism.
 *
 * DOM contract required by the commerce shim (do not change):
 *   [role="dialog"] > [role="radiogroup"] > [role="radio"][aria-checked]
 *   tier name in the FIRST <span> of each radio ("6 Boxes" / "3 Boxes" /
 *   "Subscribe & Save"), CTA text starts "Add to Cart".
 *
 * The 1-Box tier is deliberately NOT shown here (owner, July 31 2026): the
 * showcased entry point is 3 Boxes at $54.99. It stays buyable — the variant,
 * the Kaching bar and the commerce shim's `one` tier are all intact — so old
 * links and the Kaching widget still work. Restore by re-adding the opt() call
 * below; IMG.one is kept for that reason.
 */
(function () {
  'use strict';
  if (window.__hydrovaAdvPopupBound) return;
  window.__hydrovaAdvPopupBound = true;

  var CDN = 'https://cdn.shopify.com/s/files/1/0835/7924/0683/files/';
  var IMG = {
    six: CDN + 'Untitled_design_35.png?v=1784664819&width=320',
    three: CDN + 'Untitled_design_33.webp?v=1784664827&width=320',
    one: CDN + 'Untitled_design_34.webp?v=1784664819&width=320'
  };
  /* Ebook cover, from the "The-7-Day-Hydrogen-Protocol" product's media. */
  var EBOOK = CDN + 'Screenshot2026-07-30150535.png?v=1785438353&width=180';

  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="color:#fff" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg>';
  var X_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>';

  function opt(o) {
    return '' +
      '<button type="button" role="radio" aria-checked="' + (o.checked ? 'true' : 'false') + '" class="hyadv-opt" data-price="' + o.price + '">' +
        '<img alt="" width="64" height="64" loading="lazy" src="' + o.img + '">' +
        '<div class="hyadv-opt-body">' +
          '<div class="hyadv-opt-toprow">' +
            '<span class="hyadv-opt-name">' + o.name + '</span>' +
            (o.badge ? '<span class="hyadv-badge">' + o.badge + '</span>' : '') +
          '</div>' +
          '<p class="hyadv-opt-sub">' + o.sub + '</p>' +
          '<div class="hyadv-opt-priceline">' +
            '<span class="hyadv-price">$' + o.price + '</span>' +
            (o.compare ? '<span class="hyadv-compare">$' + o.compare + '</span>' : '') +
            '<span class="hyadv-perday">' + o.perday + '</span>' +
          '</div>' +
        '</div>' +
        '<span class="hyadv-radio" aria-hidden="true">' + CHECK_SVG + '</span>' +
      '</button>';
  }

  var ROOT_HTML = '' +
    '<div class="hyadv-overlay" data-hyadv-close></div>' +
    '<div role="dialog" aria-modal="true" aria-label="Choose Your Bundle" tabindex="-1" class="hyadv-drawer">' +
      '<div class="hyadv-grab" aria-hidden="true"><span></span></div>' +
      '<div class="hyadv-head">' +
        '<h2 class="hyadv-title">Choose Your Bundle</h2>' +
        '<button type="button" class="hyadv-close" aria-label="Close" data-hyadv-close>' + X_SVG + '</button>' +
      '</div>' +
      '<p class="hyadv-urgency">— Only 13 left in stock —</p>' +
      '<div class="hyadv-options" role="radiogroup" aria-label="Bundle options">' +
        opt({ name: '6 Boxes', sub: '73% off list · 6-month supply', price: '79.98', compare: '299.94', perday: '$0.44/day', img: IMG.six }) +
        opt({ name: '3 Boxes', badge: 'MOST POPULAR', sub: '63% off list · 3-month supply', price: '54.99', compare: '149.97', perday: '$0.61/day', checked: true, img: IMG.three }) +
        opt({ name: 'Subscribe & Save', badge: 'NEVER RUN OUT', sub: '3 boxes every 3 months · 3-month supply', price: '39.99', perday: '$0.44/day', img: IMG.three }) +
      '</div>' +
      '<div class="hyadv-foot">' +
        '<div class="hyadv-bonus">' +
          '<img class="hyadv-bonus-cover" src="' + EBOOK + '" alt="Cover of The 7-Day Hydrogen Protocol guide" width="46" height="59" loading="lazy">' +
          '<div class="hyadv-bonus-text">' +
            '<p class="hyadv-bonus-eyebrow">Included free with every order</p>' +
            '<p class="hyadv-bonus-title">The 7-Day Hydrogen Protocol</p>' +
            '<p class="hyadv-bonus-sub">20-page guide · daily checklist · printable tracker</p>' +
          '</div>' +
        '</div>' +
        '<p class="hyadv-fine">Free US shipping · 90-day money-back guarantee</p>' +
        '<button type="button" class="hyadv-cta">Add to Cart — $54.99</button>' +
      '</div>' +
    '</div>';

  var root = document.createElement('div');
  root.id = 'hyadv-popup';
  root.innerHTML = ROOT_HTML;
  document.body.appendChild(root);

  var drawer = root.querySelector('.hyadv-drawer');
  var cta = root.querySelector('.hyadv-cta');
  var lastFocus = null;

  function selected() { return root.querySelector('[role="radio"][aria-checked="true"]'); }

  root.querySelector('[role="radiogroup"]').addEventListener('click', function (ev) {
    var radio = ev.target.closest ? ev.target.closest('[role="radio"]') : null;
    if (!radio) return;
    var cur = selected();
    if (cur && cur !== radio) cur.setAttribute('aria-checked', 'false');
    radio.setAttribute('aria-checked', 'true');
    cta.textContent = 'Add to Cart — $' + radio.getAttribute('data-price');
  });

  function open() {
    lastFocus = document.activeElement;
    root.classList.add('hyadv-open');
    document.body.classList.add('hyadv-locked');
    setTimeout(function () { drawer.focus(); }, 320);
  }
  function close() {
    root.classList.remove('hyadv-open');
    document.body.classList.remove('hyadv-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.HydrovaAdvPopup = { open: open, close: close };

  root.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('[data-hyadv-close]')) close();
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && root.classList.contains('hyadv-open')) close();
  });

  /* Any CTA in the article opens the drawer. Anchors keep their #offer href as
     a no-JS fallback (browsers just jump nowhere harmful). */
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest ? ev.target.closest('[data-hydrova-offer], a[href="#offer"]') : null;
    if (!t) return;
    ev.preventDefault();
    open();
  });

  /* Sticky bottom bar after the reader is past the first screens. */
  var sticky = document.createElement('div');
  sticky.className = 'hyadv-sticky';
  sticky.innerHTML = '' +
    '<img class="hyadv-sticky-cover" src="' + EBOOK + '" alt="" width="34" height="43" loading="lazy">' +
    '<div class="hyadv-sticky-info">' +
      '<p class="hyadv-sticky-name">Hydrova — from $0.44/day</p>' +
      '<p class="hyadv-sticky-sub">+ free 7-day guide · 90-day guarantee</p>' +
    '</div>' +
    '<button type="button" class="hyadv-sticky-btn" data-hydrova-offer>Try It Risk-Free</button>';
  document.body.appendChild(sticky);

  var shown = false;
  function onScroll() {
    var past = (window.scrollY || document.documentElement.scrollTop) > Math.min(window.innerHeight * 1.2, 1000);
    var openNow = root.classList.contains('hyadv-open');
    var want = past && !openNow;
    if (want !== shown) {
      shown = want;
      sticky.classList.toggle('is-shown', want);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  var stickyPoll = setInterval(onScroll, 400); /* also reacts to drawer open/close */
  window.addEventListener('pagehide', function () { clearInterval(stickyPoll); });
})();
